import { FormSection, FormButtonsLayout } from 'framework/ui/layout';
import { VacancyDropdown } from 'domain/shared/newVacancy';
import { EnumDropdown, NumberInput, CreateForm } from 'framework/form';
import validationCandidateVacancyRejectForm from './validationCandidateVacancyRejectForm';
import { REGISTRATION_LOCATION } from 'domain/recruiting/recruitingBoard/shared';
import useRecruiterExtension from '../../useRecruiterExtension';
import { Box } from '@mui/material';
import { CurrencyDropdown } from 'domain/shared/core/input';

const REJECTION_REASON_CANDIDATE = {
  NO_RESPONSE: 'No response from the candidate',
  NOT_INTERESTED: 'Candidate not interested',
  NOT_LOOKING_FOR_JOB: 'Candidate not looking for a job',
  LEGALIZATION_ISSUES: 'Issues with relocation, registration, or location',
};

const CandidateVacancyRejectForm = ({ togleVacancyReject }: any) => {
  const { sendRejectionReason } = useRecruiterExtension();

  return (
    <CreateForm
      submitFormFunc={sendRejectionReason}
      getValidationSchemaFunc={() => Promise.resolve(validationCandidateVacancyRejectForm)}
      afterSubmit={{
        message: 'You are awesome! The data has been saved.',
        execute: () => {
          togleVacancyReject();
        },
      }}
    >
      <FormSection
        titleVariant="subtitle1"
        titleStyle={{ marginBottom: '4px' }}
        formStyle={{ padding: 0, border: 'none', boxShadow: 'none', width: '100%' }}
      >
        <VacancyDropdown source="vacancyGroupAlias" placeholder="Vacancy" label="" />

        <EnumDropdown options={REGISTRATION_LOCATION} placeholder="Location" label="" source="location" />

        <EnumDropdown
          options={REJECTION_REASON_CANDIDATE as Dictionary<string>}
          placeholder="Rejection reason"
          label=""
          source="rejectionReason"
        />

        <Box display="flex" alignItems="center" justifyContent="space-between" gap="10px">
          <NumberInput
            label=""
            placeholder="Min salary expectation"
            source="expectedCompensationFrom"
            sx={{ flex: '0 0 35%' }}
          />
          <NumberInput
            tooltip="Can be empty"
            label=""
            placeholder="Max salary expectation"
            source="expectedCompensationTo"
            sx={{ flex: '0 0 35%' }}
          />
          <CurrencyDropdown label="" placeholder="Currency" source="compensationCurrency" />
        </Box>

        <FormButtonsLayout onCancelAction={togleVacancyReject} />
      </FormSection>
    </CreateForm>
  );
};

export default CandidateVacancyRejectForm;
